import React, { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", message: "" });

  const handleEnquiry = (e) => {
    e.preventDefault();
    const msg = encodeURIComponent(
      `Hello SMS Gold, I would like to enquire.\n\nName: ${form.name}\nPhone: ${form.phone}\nMessage: ${form.message}`,
    );
    window.open(`https://wa.me/919898313040?text=${msg}`, "_blank");
  };

  return (
    <section
      id="visit"
      className="relative py-16 sm:py-20 md:py-28 bg-gradient-to-br from-cream via-white to-gray-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.04]">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern
              id="c-pattern"
              width="28"
              height="28"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="2" cy="2" r="1.2" fill="#800000" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#c-pattern)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-14">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-4">
            <span className="h-px w-8 bg-gold" />
            Visit Us
            <span className="h-px w-8 bg-gold" />
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-maroon font-bold leading-tight">
            Experience The <span className="gold-gradient-text">Showroom</span>
          </h2>
          <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
            Step into our boutique in Visnagar and let our family welcome yours.
            Every visit is personal, unhurried, and filled with care.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-6 lg:gap-8 mb-8 lg:mb-10">
          <div className="lg:col-span-2 bg-gradient-to-br from-maroon-dark to-maroon text-white rounded-3xl p-7 sm:p-8 md:p-10 shadow-xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-gold/20 rounded-full blur-3xl" />

            <h3 className="relative font-serif text-2xl md:text-3xl font-bold mb-6 text-gold">
              Get in Touch
            </h3>

            <div className="relative space-y-5">
              <ContactRow
                label="Address"
                value={
                  <>
                    Shivkumar Jewellers,
                    <br />
                    5/4/56, 57, 58 Swaminarayan Mandir
                    <br />
                    No Kancho, Lal Darwaja,
                    <br />
                    Visnagar, Gujarat 384315
                  </>
                }
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                }
              />
              <ContactRow
                label="Mobile"
                value={
                  <a
                    href="tel:+919898313040"
                    className="hover:text-gold transition-colors"
                  >
                    +91 98983 13040
                  </a>
                }
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                }
              />
              <ContactRow
                label="Enquiry"
                value={
                  <a
                    href="tel:+919798993336"
                    className="hover:text-gold transition-colors"
                  >
                    +91 97989 93336
                  </a>
                }
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                  </svg>
                }
              />
              <ContactRow
                label="Email"
                value={
                  <a
                    href="mailto:smsgold.vs@gmail.com"
                    className="hover:text-gold transition-colors break-all"
                  >
                    smsgold.vs@gmail.com
                  </a>
                }
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                }
              />
              <ContactRow
                label="Timings"
                value={
                  <>
                    Monday Saturday
                    <br />
                    10:00 AM to 9:00 PM
                  </>
                }
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                }
              />
            </div>

            <div className="relative mt-7 flex flex-wrap gap-3">
              <a
                href="https://wa.me/919898313040"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-gold text-maroon px-5 py-2.5 rounded-full font-semibold text-sm hover:bg-gold-light transition-colors shadow-md"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                WhatsApp
              </a>
              <a
                href="https://share.google/JpeXtzXcTmSJGaBUy"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border-2 border-gold text-gold px-5 py-2.5 rounded-full font-semibold text-sm hover:bg-gold hover:text-maroon transition-colors"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
                  <line x1="8" y1="2" x2="8" y2="18" />
                  <line x1="16" y1="6" x2="16" y2="22" />
                </svg>
                Directions
              </a>
            </div>
          </div>

          <div className="lg:col-span-3 rounded-3xl overflow-hidden shadow-xl border-4 border-white min-h-[320px] md:min-h-[460px]">
            <iframe
              title="Shivkumar Jewellers Location"
              src="https://www.google.com/maps?q=Shivkumar+Mangaldas+Soni&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "100%" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <div className="bg-white rounded-3xl p-6 sm:p-8 md:p-10 shadow-xl border border-gold/30 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-60 h-60 bg-gold/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-60 h-60 bg-maroon/10 rounded-full blur-3xl" />

          <div className="relative grid md:grid-cols-2 gap-8 md:gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-gold-dark font-semibold mb-3">
                <span className="h-px w-6 bg-gold" />
                Enquiry Now
              </span>
              <h3 className="font-serif text-2xl sm:text-3xl md:text-4xl text-maroon font-bold mb-3 leading-tight">
                Have a question? <br />
                <span className="gold-gradient-text">We'd love to help.</span>
              </h3>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                Share your enquiry below and our team will reach out to you
                directly on WhatsApp. For immediate assistance, call us at{" "}
                <a
                  href="tel:+919798993336"
                  className="text-maroon font-semibold hover:text-gold-dark"
                >
                  +91 97989 93336
                </a>
                .
              </p>
            </div>

            <form onSubmit={handleEnquiry} className="space-y-4">
              <div>
                <label className="block text-[11px] uppercase tracking-[0.2em] text-maroon font-semibold mb-1.5">
                  Your Name
                </label>
                <input
                  type="text"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl border border-gold/30 bg-cream/50 focus:outline-none focus:border-maroon focus:bg-white transition-colors text-sm"
                  placeholder="Enter your name"
                />
              </div>
              <div>
                <label className="block text-[11px] uppercase tracking-[0.2em] text-maroon font-semibold mb-1.5">
                  Mobile Number
                </label>
                <input
                  type="tel"
                  required
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl border border-gold/30 bg-cream/50 focus:outline-none focus:border-maroon focus:bg-white transition-colors text-sm"
                  placeholder="+91 XXXXX XXXXX"
                />
              </div>
              <div>
                <label className="block text-[11px] uppercase tracking-[0.2em] text-maroon font-semibold mb-1.5">
                  Your Enquiry
                </label>
                <textarea
                  required
                  rows="3"
                  value={form.message}
                  onChange={(e) =>
                    setForm({ ...form, message: e.target.value })
                  }
                  className="w-full px-4 py-3 rounded-xl border border-gold/30 bg-cream/50 focus:outline-none focus:border-maroon focus:bg-white transition-colors text-sm resize-none"
                  placeholder="Tell us what you are looking for"
                />
              </div>
              <button
                type="submit"
                className="w-full inline-flex items-center justify-center gap-2 bg-maroon text-white px-6 py-3 rounded-full font-semibold hover:bg-maroon-dark transition-colors shadow-lg"
              >
                Send Enquiry via WhatsApp
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactRow({ icon, label, value }) {
  return (
    <div className="flex items-start gap-4">
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/20 border border-gold/40 text-gold flex items-center justify-center">
        {icon}
      </div>
      <div className="min-w-0">
        <div className="text-[11px] uppercase tracking-[0.25em] text-gold-light font-semibold mb-1">
          {label}
        </div>
        <div className="text-sm md:text-base leading-relaxed">{value}</div>
      </div>
    </div>
  );
}
